import { Component } from '@angular/core';

@Component({
  selector: 'app-topbar-apps',
  imports: [],
  templateUrl: './topbar-apps.component.html',
  styleUrl: './topbar-apps.component.scss'
})
export class TopbarAppsComponent {

}
